import groupBy from 'lodash/groupBy';

import { INSTRUCTOR_CATEGORIES } from '../data/instructorCategories';

function generateSbatGroupInstructor(instructor) {
  return (
    instructor && {
      value: instructor.id,
      label: instructor.user?.name,
      type: instructor.instructor_type,
      email: instructor.user?.email,
    }
  );
}

function generateSbatGroupInstructors(instructors) {
  const categorizedInstructors = groupBy(instructors, 'category');

  return {
    [INSTRUCTOR_CATEGORIES.primary]: generateSbatGroupInstructor(
      categorizedInstructors?.primary?.[0]?.instructor
    ),
    [INSTRUCTOR_CATEGORIES.secondary]: generateSbatGroupInstructor(
      categorizedInstructors?.secondary?.[0]?.instructor
    ),
    [INSTRUCTOR_CATEGORIES.other]:
      categorizedInstructors?.other?.map((o) =>
        generateSbatGroupInstructor(o.instructor)
      ) || [],
  };
}
export default generateSbatGroupInstructors;
